import { initDB } from './dbService';

// Sauvegarder une préférence
export async function savePref(key, value) {
  try {
    const db = await initDB();
    const transaction = db.transaction(['prefs'], 'readwrite');
    const store = transaction.objectStore('prefs');

    await new Promise((resolve, reject) => {
      const request = store.put({
        id: key,
        value: value
      });
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error(`Erreur lors de la sauvegarde de la préférence ${key}:`, error);
  }
}

// Charger une préférence
export async function loadPref(key, defaultValue = null) {
  try {
    const db = await initDB();
    const transaction = db.transaction(['prefs'], 'readonly');
    const store = transaction.objectStore('prefs');

    return new Promise((resolve, reject) => {
      const request = store.get(key);
      request.onsuccess = () => {
        const result = request.result;
        resolve(result ? result.value : defaultValue);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error(`Erreur lors du chargement de la préférence ${key}:`, error);
    return defaultValue;
  }
}

// Fonctions spécifiques pour les salaires
export async function isSalairesEnabled() {
  return await loadPref('enableSalaires', false);
}

export async function setSalairesEnabled(enabled) {
  await savePref('enableSalaires', enabled);
}

// Fonctions spécifiques pour les effets visuels
export async function isHighlightEffectsEnabled() {
  return await loadPref('highlightEffects', true); // Par défaut activé
}

export async function setHighlightEffectsEnabled(enabled) {
  await savePref('highlightEffects', enabled);
}